export enum BatteryStatus {
  HIGH = 'High',
  LOW = 'Low',
}
